// extracted by mini-css-extract-plugin
export default {"notify":"wyrq85","text":"ESM86O","mobile":"sWl2rC"};